module.exports = __webpack_public_path__ + "img/m3x5yuanmaodingmu.prt.1736d153.jpg";